import React from 'react';
import { Section } from './Section';
import { X, Check } from 'lucide-react';
const academiaTable = [{
  feature: 'No sabés cómo fijar tus precios',
  without: true,
  with: 'Guía de precios según zona, modalidad y categoría'
}, {
  feature: 'No te diferenciás de otros profes',
  without: true,
  with: 'Propuesta de valor clara lista para comunicar'
}, {
  feature: 'No sabés cómo conseguir el espacio',
  without: true,
  with: 'Modelos de convenio con clubes e instituciones'
}, {
  feature: 'No sabés cómo armar los grupos',
  without: true,
  with: 'Sistema de organización de grupos y horarios'
}, {
  feature: 'No tenés documentación básica',
  without: true,
  with: 'Contratos, autorizaciones y reglamento listos'
}];
const digitalTable = [{
  feature: 'No sabés qué publicar en redes',
  without: true,
  with: 'Calendario de 30 días de contenido listo'
}, {
  feature: 'No te diferenciás online',
  without: true,
  with: 'Perfil de Instagram optimizado paso a paso'
}, {
  feature: 'No convertís seguidores en alumnos',
  without: true,
  with: 'Sistema para atraer y convertir desde redes'
}, {
  feature: 'No sabés cómo filmar entrenamientos',
  without: true,
  with: 'Guía de contenido con el celular desde la cancha'
}, {
  feature: 'Sin identidad profesional digital',
  without: true,
  with: 'Plantillas de Stories y posts editables en Canva'
}];
export function EliteComparison() {
  return <Section darker className="border-t border-gold-500/10" data-id="element-70">
      <div className="text-center mb-8 md:mb-16" data-id="element-71">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-2 md:mb-4" data-id="element-72">
          ¿Qué agrega el Pack Élite™?
        </h2>
        <p className="text-base md:text-xl text-gold-400" data-id="element-73">
          El sistema para profes que no solo quieren entrenar — quieren crecer
        </p>
      </div>

      <div className="max-w-5xl mx-auto space-y-8 md:space-y-16" data-id="element-74">
        {/* Tu Academia Table */}
        <div data-id="element-75">
          <div className="text-center mb-4 md:mb-8" data-id="element-76">
            <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-1 md:mb-2" data-id="element-77">
              Tu Academia de Volley
            </h3>
            <p className="text-sm md:text-base text-gray-400 italic" data-id="element-78">
              "Todo para crear, lanzar y gestionar tu propio espacio de volley"
            </p>
          </div>

          {/* Desktop Table */}
          <div className="hidden md:block overflow-x-auto rounded-2xl border border-navy-700 bg-navy-900" data-id="element-79">
            <table className="w-full text-left border-collapse" data-id="element-80">
              <thead data-id="element-81">
                <tr className="bg-navy-800" data-id="element-82">
                  <th className="p-4 border-b border-navy-700 text-gray-400 font-semibold w-1/3" data-id="element-83">
                    Situación actual
                  </th>
                  <th className="p-4 border-b border-navy-700 text-red-400 font-semibold text-center w-1/6" data-id="element-84">
                    Sin Pack Élite
                  </th>
                  <th className="p-4 border-b border-navy-700 text-gold-400 font-semibold w-1/2" data-id="element-85">
                    Con Tu Academia de Volley
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-86">
                {academiaTable.map((row, i) => <tr key={i} className="border-b border-navy-800/50 hover:bg-navy-800/30 transition-colors" data-id="element-87">
                    <td className="p-4 text-gray-300" data-id="element-88">{row.feature}</td>
                    <td className="p-4 text-center" data-id="element-89">
                      <X className="w-5 h-5 text-red-500 mx-auto" data-id="element-90" />
                    </td>
                    <td className="p-4 text-white font-medium flex items-center gap-2" data-id="element-91">
                      <Check className="w-5 h-5 text-gold-500 shrink-0" data-id="element-92" />
                      {row.with}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-3" data-id="element-93">
            {academiaTable.map((row, i) => <div key={i} className="bg-navy-900 p-4 rounded-xl border border-navy-700 space-y-3" data-id="element-94">
                <div className="flex items-start gap-2 text-gray-400 text-sm" data-id="element-95">
                  <X className="w-4 h-4 text-red-500 shrink-0 mt-0.5" data-id="element-96" />
                  <span data-id="element-97">{row.feature}</span>
                </div>
                <div className="flex items-start gap-2 text-white font-medium text-sm" data-id="element-98">
                  <Check className="w-4 h-4 text-gold-500 shrink-0 mt-0.5" data-id="element-99" />
                  <span data-id="element-100">{row.with}</span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Profe Digital Table */}
        <div data-id="element-101">
          <div className="text-center mb-4 md:mb-8" data-id="element-102">
            <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-1 md:mb-2" data-id="element-103">
              Profe Digital: Más Alumnos con Redes Sociales
            </h3>
            <p className="text-sm md:text-base text-gray-400 italic" data-id="element-104">
              "Tu presencia digital completa para llenar tus grupos"
            </p>
          </div>

          {/* Desktop Table */}
          <div className="hidden md:block overflow-x-auto rounded-2xl border border-navy-700 bg-navy-900" data-id="element-105">
            <table className="w-full text-left border-collapse" data-id="element-106">
              <thead data-id="element-107">
                <tr className="bg-navy-800" data-id="element-108">
                  <th className="p-4 border-b border-navy-700 text-gray-400 font-semibold w-1/3" data-id="element-109">
                    Situación actual
                  </th>
                  <th className="p-4 border-b border-navy-700 text-red-400 font-semibold text-center w-1/6" data-id="element-110">
                    Sin Pack Élite
                  </th>
                  <th className="p-4 border-b border-navy-700 text-gold-400 font-semibold w-1/2" data-id="element-111">
                    Con Profe Digital
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-112">
                {digitalTable.map((row, i) => <tr key={i} className="border-b border-navy-800/50 hover:bg-navy-800/30 transition-colors" data-id="element-113">
                    <td className="p-4 text-gray-300" data-id="element-114">{row.feature}</td>
                    <td className="p-4 text-center" data-id="element-115">
                      <X className="w-5 h-5 text-red-500 mx-auto" data-id="element-116" />
                    </td>
                    <td className="p-4 text-white font-medium flex items-center gap-2" data-id="element-117">
                      <Check className="w-5 h-5 text-gold-500 shrink-0" data-id="element-118" />
                      {row.with}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-3" data-id="element-119">
            {digitalTable.map((row, i) => <div key={i} className="bg-navy-900 p-4 rounded-xl border border-navy-700 space-y-3" data-id="element-120">
                <div className="flex items-start gap-2 text-gray-400 text-sm" data-id="element-121">
                  <X className="w-4 h-4 text-red-500 shrink-0 mt-0.5" data-id="element-122" />
                  <span data-id="element-123">{row.feature}</span>
                </div>
                <div className="flex items-start gap-2 text-white font-medium text-sm" data-id="element-124">
                  <Check className="w-4 h-4 text-gold-500 shrink-0 mt-0.5" data-id="element-125" />
                  <span data-id="element-126">{row.with}</span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}